
(function(){
  // JavaScript Integration Configurations
  var giftCardUse = false
  var freeShippingXVal = 0
  var baseShippingLabel = ""
  var baseShippingPrice = 0
  var orderNotesId = "cart-note"
  var enableGaTracking = false
  var enableFacebookPixel = false
  var shopifyConfirmationRenderer = false

  // DO NOT MODIFY BEYOND THIS POINT (UNLESS SPECIALLY REFERENCED MODIFICATION)

  var expectedOrigins = [
    "https://connect-sandbox.bolt.com", "https://connect.bolt.com"
  ];
  var cartUpdateURLs = [
    '/cart/change.js',
    '/cart/update.js',
    '/cart/add.js',
  ];

  var insertGiftCardButton = function() {
    var checkoutButton =  $('.shopify-checkout').find('#original-button')
    	if (checkoutButton) {
           $('.bolt-additional-checkout-buttons').each(function() {
                if (giftCardUse) {
                    var clone = checkoutButton.clone()
                    clone.attr("value", "USE GIFT CARD");
                    clone.attr("id", "gift-card-button");
                    clone.css("display", "block");
                    clone.html("USE GIFT CARD");
                    $(this).append(clone);
                }
        });
    }
  }
  
  var requiresShipping = true;
  var boltSubtotals = 0;
  var orderToken = "";
  var orderNote = "";
  var reference = "";
  var successUrl = "";
  var getCartRequest;
  var getCartResponse;

  var trackGaStep = function(step) {
    if (!enableGaTracking) {
      return;
    }
    ga('ec:setAction','checkout', {
      'step': step,
    });
    ga('send', 'event', 'Checkout', 'step');
  };

  var successCallback = function(transaction, callback) {
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function() {
        reference = transaction.reference;
        if (localStorage) {
    		localStorage.setItem('bolt_conf', true);
        }
        if (shopifyConfirmationRenderer) {
            pollForShopifyOrderUrl(transaction, callback);
        	additionalTrackingScript(transaction);
        } else {
        	callback();
        }
        if (enableGaTracking) {
          ga('ec:setAction', 'purchase', {     
            'id': transaction.reference,                     
            'revenue': String(transaction.amount.amount / 100.0)              
          });
          ga('send', 'pageview');

          trackGaStep(6);
        }
        if (enableFacebookPixel) {
          fbq('track', 'Purchase', {
            value: transaction.amount.amount / 100,
            currency: 'USD',
          });
        }
      }
    });
  };
 
  var additionalTrackingScript = function(transaction) {
  }
  var pollForShopifyOrderUrl = function(transaction, callback) {
    var url = window.location.protocol + "//" + window.location.host + 
        "/apps/boltapp/v1/shopify/order/confirmation?order_token=" + orderToken +
        "&reference=" + reference +
        "&format=json";
    var MaxRetryCount = 10;
    var currentRetryCount = 0;
    var cart = "";
    var orderUrlFunc = function(){
      $.ajax({
        url: url,
        success: function(result) {
          successUrl = (result && result.cart && result.cart.merchant_order_url) || "";
          console.log(result.cart);
        },
        complete: function(data){
          currentRetryCount = currentRetryCount + 1;
          if (successUrl === "") {
            if (currentRetryCount <= MaxRetryCount) {
	          window.setTimeout(orderUrlFunc, 2000);
            } else {
              callback();
              console.log("time out after " + MaxRetryCount + "attempts");
            }
          } else {
            console.log("retrieving shopify order_number for " + successUrl);
            callback();
          }
        }
      });
    };
    window.setTimeout(orderUrlFunc, 2000);
  }
    
  var inventoryChecksRemaining = 0;
  var orderValidation = function(callback) {
    var inventoryCheckCallback = function(success, product) {
      var response = {
        success: success,
        errorMessage: !success && product ? product + " is out of stock." : null,
      };
      callback(response);
    }

    // This event is triggered after the checkout form is loaded, cart response will be present.
    inventoryChecksRemaining = getCartResponse.items.length;

    for (var i = 0; i < inventoryChecksRemaining; i++) {
      productInventoryCheck(getCartResponse.items[i], inventoryCheckCallback);
    }
  }

  function trunc(x) {
    // Math.trunc does not exist in IE
    if (Math.trunc) {
      return Math.trunc(x);
    } else {
      var n = x - x%1;
      return n===0 && (x<0 || (x===0 && (1/x !== 1/0))) ? -0 : n;
    };
  }
  function logError(err) {
    console.error(err.message, err.exception);
    if (window.boltBugsnagClient) {
      window.boltBugsnagClient.leaveBreadcrumb(err.message);
      window.boltBugsnagClient.notify(err.exception);
    } else {
      console.error("bugsnag is not setup");
    }
  }
  // Workaround for cart which doesn't require shipping. Posting 'no shipping' as shipping option.
  function postNoShippingAsOption(target, origin) {
    var noShipping = {
      service: 'No shipping',
      cost: {
        amount: 0,
      currency: "USD",
        currency_symbol: "$",
      }
    };
    var message = {
      type: "fetched_shopify_shipping",
      shipping_options: [noShipping],
    };
    target.postMessage(JSON.stringify(message), origin);
  }
  function receiveMessage(event) {
    if (!event) {
      return;
    }
    var origin = event.origin || event.originalEvent.origin;
    if (expectedOrigins.indexOf(origin) < 0 || !event.data) {
      return;
    }
    var eventData;
    try {
      eventData = JSON.parse(event.data);
    } catch (e) {
      return;
    }

    if (eventData && eventData.type === 'bolt_order_token') {
      orderToken = eventData.token;
      return;
    }

    if (!eventData || eventData.type !== 'fetch_shopify_shipping') {
      return;
    }

    if (!requiresShipping) {
      postNoShippingAsOption(event.source, origin);
      return;
    }

    var partialURL = "/cart/shipping_rates.json?";
    var postalCodeParam = "shipping_address%5Bzip%5D=" + encodeURIComponent(eventData.address.postal_code);
    var countryCodeParam = "shipping_address%5Bcountry%5D=" + encodeURIComponent(eventData.address.country_code);
    var provinceCodeParam = "shipping_address%5Bprovince%5D=" + encodeURIComponent(eventData.address.region);
    var fullURL = partialURL + "&" + postalCodeParam + "&" + countryCodeParam + "&" + provinceCodeParam;
    $.ajax({
      type: "POST",
      url: fullURL,
      dataType: "json",
      error: function(xhr, textStatus, errorThrown) {
        var response = {
          type: "fetched_shopify_shipping",
          error: "Request failed " + textStatus + " " + errorThrown,
        };
        event.source.postMessage(JSON.stringify(response), origin);
      },
      success: function(shippingOptionsResponse) {
        if (freeShippingXVal != 0) {
          var discountAmount = 0;
          for (var i = 0; i < eventData.discounts.length; i++) {
            discountAmount += parseInt(parseFloat(eventData.discounts[i].amount.replace(/[^0-9.-]+/g,"")) * 100);
          }
          var totalAfterDiscount = boltSubtotals - discountAmount;
        }    
        try {
          var boltShippingOptions = [];
          var i = 0;
          var defaultCurrency = "USD";
          var defaultCurrencySymbol = "$";
          for (; i < shippingOptionsResponse.shipping_rates.length; i++) {
            var boltShippingOption = {};
            boltShippingOption.service = shippingOptionsResponse.shipping_rates[i].name;
            boltShippingOption.cost = {};
            boltShippingOption.cost.currency = shippingOptionsResponse.shipping_rates[i].currency || defaultCurrency;
            boltShippingOption.cost.amount = trunc(parseFloat(shippingOptionsResponse.shipping_rates[i].price)  * 100);
            boltShippingOption.cost.currency_symbol = currencySymbolByISOCurrencyCode[shippingOptionsResponse.shipping_rates[i].currency] || defaultCurrencySymbol;
            if (freeShippingXVal != 0) {
              if (boltShippingOption.cost.amount == 0 && discountAmount > 0 && totalAfterDiscount < freeShippingXVal) {
                boltShippingOption.service = baseShippingLabel;
                boltShippingOption.cost.amount = baseShippingPrice;
                boltShippingOptions.push(boltShippingOption);
              } else {
                boltShippingOptions.push(boltShippingOption);
              }
            } else {
            	boltShippingOptions.push(boltShippingOption);
            }
            if (boltShippingOption.cost.currency) {
              defaultCurrency = boltShippingOption.cost.currency;
            }
            if (boltShippingOption.cost.currency_symbol) {
              defaultCurrencySymbol = boltShippingOption.cost.currency_symbol;
            }
          }
          var response = {
            type: "fetched_shopify_shipping",
            shipping_options: boltShippingOptions,
            address: eventData.address
          };

          event.source.postMessage(JSON.stringify(response), origin);
        } catch (e) {
          var response = {
            type: "fetched_shopify_shipping",
            error: "Error while fetching shipping " + e,
          };
          event.source.postMessage(JSON.stringify(response), origin);
        }
      }
    });
  }

  function productInventoryCheck(item, inventoryCheckCallback) {
    $.ajax({
      type: "GET",
      url: "/products/" + item.handle + ".json",
      dataType: "json",
      success: function(response) {
        var product = response.product;
        var variants = product.variants;
        var variant = null;

        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === item.variant_id) {
            variant = variants[i];
            break;
          }
        }

        if (variant == null) {
          inventoryCheckCallback(false, item.title);
          return;
        }

        var isShopifyManagement = variant.inventory_management === "shopify";
        var isInventoryEnforced =  variant.inventory_policy === "deny";
        var insufficientQuantity = variant.inventory_quantity < item.quantity;
        var denyPurchase = isShopifyManagement && isInventoryEnforced && insufficientQuantity;

        if (denyPurchase) {
          inventoryCheckCallback(false, item.title);
        } else {
          inventoryChecksRemaining--;

          if (inventoryChecksRemaining == 0) {
            inventoryCheckCallback(true, null);
          }
        }
      },
      error: function(xhr, status, errorThrown) {
        inventoryCheckCallback(false, item.title);
        logError({message: 'Error running product inventory check', exception: errorThrown});
      }
    });
  }

  function loadCart() {
    if (typeof BoltCheckout === "undefined") {
      return;
    }
    if (typeof $ !== "undefined" && $(".bolt-checkout-button") && $(".bolt-checkout-button").length === 0) {
      // Not a cart page.
      return;
    }
    var hints = {};
    
     
    BoltCheckout.configure(
      new Promise(function(resolve, reject) {
        $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
          success: function(parsedCart) {
            // Cache cart response which may be used for inventory check
            getCartResponse = parsedCart;

            var boltCart = {
              "authcapture": true
            };
            if (orderNote) {
              boltCart.userNote = orderNote;
            }
            var i = 0;
            boltCart.items = [];
            if (parsedCart.items.length == 0) {
              return;
            }
            requiresShipping = false;
            boltSubtotals = 0;
            for (;i < parsedCart.items.length; i++) {
              var boltItem = {};
              boltItem.image = parsedCart.items[i].image;
              boltItem.desc = parsedCart.items[i].product_description;
              boltItem.name = parsedCart.items[i].title;
              boltItem.reference = parsedCart.items[i].variant_id;
              boltItem.shopifyProductVariantReference = parsedCart.items[i].variant_id;
              boltItem.shopifyProductReference = parsedCart.items[i].product_id;
              boltItem.sku = parsedCart.items[i].sku;
              boltItem.quantity = parsedCart.items[i].quantity;
              boltItem.price = "$" + (parsedCart.items[i].price / 100.0).toString();
              boltItem.options = parsedCart.items[i].variant_title;
              boltItem.taxable = parsedCart.items[i].taxable;
              boltItem.properties = [];
              var properties = parsedCart.items[i].properties || {};
              for (var key in properties) {
                if (properties.hasOwnProperty(key)) {
                  boltItem.properties.push({ name: key, value: properties[key] });
                }
              }
              boltCart.items.push(boltItem);
              if (freeShippingXVal != 0) {
                boltSubtotals = boltSubtotals + ( parsedCart.items[i].price * parsedCart.items[i].quantity );
              }
              requiresShipping |= parsedCart.items[i].requires_shipping;

              if (enableGaTracking) {
                ga('ec:addProduct', {
                  'id': boltItem.sku,
                  'name': boltItem.name,
                  'variant': boltItem.options,
                  'price': (parsedCart.items[i].price / 100.0).toString(),
                  'quantity': boltItem.quantity
                  });
                ga('send', 'event', 'UX', 'click', 'add to cart');
              }
            }
            boltCart.currency = {
              "currency_code": "USD",
              "currency_symbol": "$"
            };
            resolve(boltCart);
          },
          error: function(xhr, status, errorThrown) {
            logError({message: 'Error loading cart with status: ' + status, exception: errorThrown});
            reject(errorThrown);
          }
        });
      }),
      hints,
      {
        check: function() {
          trackGaStep(1);
          return true;
        },
        onCheckoutStart: function() {
          trackGaStep(2);
          if (enableFacebookPixel) {
            fbq('track', 'InitiateCheckout');
          }
        },
        onShippingDetailsComplete: function() {
          trackGaStep(3);
        },
        onShippingOptionsComplete: function() {
          trackGaStep(4);
        },
        onPaymentSubmit: function() {
          trackGaStep(5);
          if (enableFacebookPixel) {
            fbq('track', 'AddPaymentInfo');
          }
        },
        success: successCallback,
        close: function() {
          try {
            if (successUrl) {
              window.location = successUrl;
            }
            else if (orderToken && reference) {
              window.location = "/apps/boltapp/v1/shopify/order/confirmation?order_token=" + orderToken + "&reference=" + reference;
            }
          } catch (e) {
            logError({message: 'An exception occurred redirecting', exception: e});
          }
        },
        orderValidation: orderValidation
      }
    );
  }

  // Prevent error when the script is loaded multiple time for some reason.
  if (!window.boltMessageEventListener) {
    window.addEventListener("message", receiveMessage, false);
    window.boltMessageEventListener = receiveMessage;
  }

  $(document).ready(function(){
    $(document).ajaxComplete(function(event, xhr, settings) {
      for (var i = 0; i < cartUpdateURLs.length; i++) {
        if (settings && settings.url === cartUpdateURLs[i] && (!settings.data || !(settings.data.includes("bolt=true")))) {
          loadCart();
        }
      }
    });
    loadCart();
    if (giftCardUse) {
      insertGiftCardButton();
    }
    window.boltLoadCart = loadCart;
    $(".bolt-checkout-button").css("width", "auto");
    $(document).on('DOMNodeInserted', function(e) {
      if ($(e.target).hasClass('bolt-checkout-button-button')) {
        $(e.target).css("margin-right", "0px");
        $(e.target).css("width", "100%");
      }
      if ($(e.target).hasClass('bolt-checkout-button-cards')) {
        $(e.target).css("float", "none");
        $(e.target).css("width", "auto");
      }
    });
    
    if (orderNotesId != "") {
      $("#" + orderNotesId).on('input', function() {
        console.log("HERE");
        orderNote = $("#" + orderNotesId).val();
        loadCart();
      });
    }
  });
})();

if (typeof BoltCheckout !== "undefined") {
  BoltCheckout.configure();
}
